import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';
import { ModalRatingAndNumReviews } from '../ModalRatingAndNumReviews';

export const AcneBodyWashModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        {modal.title}
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      <ModalRatingAndNumReviews modalCard={modalCard} />
      <Typography className="cur-mt-4">
        Body acne, handled. A splash of our dermatologist-designed body wash
        treats and helps prevent acne—plus washes your pores of regular dirt and
        grime. Our body wash is formulated with just enough salicylic acid to be
        tough on acne but kind for all skin types, so you can use its lightly
        foaming goodness every day.
      </Typography>
      <Typography className="cur-mt-4">
        Massage onto damp skin. Leave on for a minute, then rinse off.
      </Typography>
      <Typography className="cur-mt-4" weight="bold">
        Key Ingredient
      </Typography>
      <Typography className="cur-mt-2">
        <strong>Salicylic acid (2%)</strong> - Goes deep into pores to clear
        away dead skin cells and excess oil
      </Typography>
      <ul className="cur-list-disc cur-ml-4">
        <li className="cur-mt-4">
          <Typography>
            Salicylic acid may not be a good choice for you if you are allergic
            to aspirin or NSAIDs (non-steroidal anti-inflammatory drugs).
          </Typography>
        </li>
        <li className="cur-mt-4">
          <Typography>
            If you are pregnant, please see your OB/GYN for approval before
            using.
          </Typography>
        </li>
      </ul>
      <IngredientsAccordion
        body="2% Salicylic Acid, Water, Sodium C14-16 Olefin Sulfonate, Glycerin,
            Cocamidopropyl Betaine, Cocamidopropyl Dimethylamine, Polyglyceryl-4
            Caprate, Polyglyceryl-6 Caprylate, Hydroxypropyl Methylcellulose,
            Phenoxyethanol, Sodium Chloride, Zinc Pyrithione, Sodium Hydroxide,
            Polyquaternium-7, Ethylhexylglycerin, Melaleuca Alternifolia (Tea
            Tea) Leaf Oil, Disodium EDTA, Sodium Benzoate"
        title="Full list of ingredients"
      />
    </>
  );
};
